import { RadioGroup, RadioGroupProps } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';

interface iRHFRadioGroup extends RadioGroupProps {
  name: string;
  control: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  children: React.ReactNode;
}

export function RHFRadioGroup({
  name,
  control,
  children,
  ...props
}: iRHFRadioGroup) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <RadioGroup
            aria-labelledby={`radiogroup-${name}`}
            name={name}
            onChange={(e) => {
              const value = e.target.value;
              if (value) {
                field.onChange(value);
              }
            }}
            value={field.value}
            {...props}
          >
            {children}
          </RadioGroup>
        );
      }}
    />
  );
}
